import { BaseIP } from "./CommonApi";

//192.168.29.102:8082/techno-muhurt/muhurt/userLogin/getRegisteredUserList
export const getRegisteredUserListAPIURL = BaseIP + "muhurt/userLogin/getRegisteredUserList";

//192.168.29.102:8082/techno-muhurt/muhurt/userLogin/updateUserStatus?id=1&status=1
// Resp:: UPDATED

export const updateUserStatusAPIURL = BaseIP + "muhurt/userLogin/updateUserStatus";